module.exports = __webpack_public_path__ + "static/media/worldwide-large.e15d2e27.jpg";